<section id="livetraining" class="blog" style="padding-top: 170px;background-color: #f5f5f5;">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 entries" data-aos="fade-up" data-aos-delay="200">
                <article class="entry entry-single">

                    <h2 class="entry-title">
                        <a>{{eventDetails.coursename}}</a>
                    </h2>
                    <div class="entry-content">
                        <div class="row">
                            <div class="col-lg-12"><i class="fa fa-clock-o theme_color"></i> <a>&nbsp;
                                    <b class="theme_color">When</b> :
                                    {{eventDetails.datetime}}</a></div>
                        </div>

                        <div class="pt-2"></div>

                        <div class="row">
                            <div class="col-lg-12"><i class="fa fa-building theme_color"></i> <a>&nbsp;<b
                                        class="theme_color">Where</b> :
                                    {{eventDetails.company}} ({{eventDetails.site}})</a></div>
                        </div>

                        <div class="pt-2"></div>

                        <div class="row">
                            <div class="col-lg-12"><i class="fa fa-user theme_color"></i> <a>&nbsp;<b
                                        class="theme_color">Instructor</b> :
                                    {{eventDetails.instructor}}</a></div>
                        </div>

                    </div>
                </article>
            </div>
        </div>

        <div class="row">

            <div class="col-lg-6" data-aos="fade-left" data-aos-delay="400">

                <div class="sidebar">
                    <h3 class="sidebar-title">Guest User Login</h3>
                    <div class="sidebar-item search-form">
                        <input type="number" [(ngModel)]="trainingCode" class="form-control" placeholder="Meeting Code"
                            pattern="[0-9]*" maxlength="6" (keyPress)="keyPress($event)" />
                        <button (click)="meetingCodeSubmit()" style="outline: none;"><i
                                class="fa fa-arrow-right"></i></button>                        
                    </div>

                    <div class="row">
                        <div class="ml-4" [innerHtml]='msg' *ngIf="msg" style="color: red;"></div>
                    </div>

                </div>
                

            </div>

            <div class="col-lg-6" data-aos="fade-left" data-aos-delay="600">
                <div class="sidebar">
                    <h3 class="sidebar-title">DMS Users</h3>
                    <div class="sidebar-item recent-posts">
                        <div class="post-item clearfix read-more">
                            <a class="btn btn-primary" href="https://dms.sficompliance.com/" target="_blank" role="button">DMS Login</a>                            
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</section><!-- End Blog Section -->